export const UPDATE_EDIT_PROFILE_FORM = 'UPDATE_EDIT_PROFILE_FORM';
export const EDIT_PROFILE_CHANGE_VALUE = 'EDIT_PROFILE_CHANGE_VALUE';